import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const rolesBaseEndpoint = ENDPOINTS.ROLES;

// Daily Orders API
export const rolesApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["roles", "rolePermissions", "employees"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getRoles: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${rolesBaseEndpoint}`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => response,
        // providesTags: () => [{ type: "dailyOrders" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      addRole: builder.mutation({
        query: (requestData) => ({
          url: `${rolesBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "roles" }],
      }),
      updateRole: builder.mutation({
        query: (requestData) => ({
          url: `${rolesBaseEndpoint}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "roles" }],
      }),
      assignUsersToRole: builder.mutation({
        query: ({ roleId, requestData }) => ({
          url: `${rolesBaseEndpoint}assign-users/${roleId}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [
          { type: "roles" },
          { type: "rolePermissions" },
          { type: "employees" },
        ],
      }),
      getUsersAssignedToRole: builder.query({
        query: (roleId) => ({
          url: `${rolesBaseEndpoint}users/${roleId}`,
        }),
        transformResponse: (response) => response,
        providesTags: () => [
          { type: "roles" },
          { type: "employees" },
          { type: "rolePermissions" },
        ],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetRolesQuery,
  useAddRoleMutation,
  useAssignUsersToRoleMutation,
  useLazyGetUsersAssignedToRoleQuery,
} = rolesApi;
